import React, { ReactElement } from 'react';
import './InkyPenProgressBar.scss';

const InkyPenProgressBar = ({ fill }): ReactElement => {

    return (
        <div className='inkypen-progressbar-container'>
            <div role="progressbar" aria-label={'reading progress is ' + fill}
                 className={`inkypen-progressbar-fill ${fill?.toString() === '100' && 'inkypen-progressbar-fill-full'}`}
                 style={{ width: fill?.toString() + '%' }}>
                <div role="progressbar" aria-label={'reading progress is ' + fill} className='inkypen-progressbar-fill-cover' />
                {fill?.toString() !== '100' && <div className='inkypen-progressbar-tip' />}
            </div>
        </div>
    );
};

export default InkyPenProgressBar;
